import { customValidators } from "src/app/_helpers/customValidators";
import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { globalHelper } from "src/app/_helpers/global";
import { ThisPlatform } from "src/app/_services/platform.service";
import { CompanyGroupService } from "../group-service";
import { CompanyGroup, CompanyGroupType } from "../gorup.model";
import { SelectModalUserComponent } from "src/app/app/_component/select-modal-user/select-modal-user.component";
import { User, UserBasic } from "src/app/_models/user.model";

@Component({
  selector: "app-detail-group",
  templateUrl: "./detail-group.page.html",
  styleUrls: ["./detail-group.page.scss"],
})
export class DetailCompanyGroupPage implements OnInit {
  constructor(
    public companyGroupServ: CompanyGroupService,
    private modalController: ModalController,
    public p: ThisPlatform,
    private el: ElementRef,
    public translate: TranslateService,
    private modalCtrl: ModalController
  ) {}

  @Input()
  companyId: number;

  @Input()
  groupType: CompanyGroupType;

  @Input()
  companyGroup: CompanyGroup;

  validationError: boolean = false;
  growAuto = false;

  form: FormGroup;

  addUserModalOpen: boolean = false;
  saving: boolean = false;

  ngOnInit() {
    if (!this.companyGroup) {
      this.companyGroupServ.companyGroup = new CompanyGroup();
    } else {
      this.companyGroupServ.companyGroup = this.companyGroup;
    }
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl(null, {
        updateOn: "blur",
        validators: [Validators.required, customValidators.trimValidator()],
      }),
      description: new FormControl(null, {
        updateOn: "blur",
      }),
    });
    if (this.companyGroup) {
      const { name, description } = this.companyGroup;
      this.form.patchValue({
        name: name,
        description: description,
      });
    }
  }

  Save() {
    this.saving = true;
    if (!this.form.valid) {
      this.validationError = true;
      globalHelper.scrollToFirstInvalidControl(this.el);
      this.saving = false;
      return;
    }
    this.companyGroupServ.companyGroup.type = this.groupType;
    this.companyGroupServ.companyGroup.idCompany = Number(this.companyId);
    this.companyGroupServ.companyGroup.name = this.form.value.name;
    this.companyGroupServ.companyGroup.description = this.form.value.description;
    // if (this.companyGroupServ.companyGroup.users === undefined) {
    //   this.companyGroupServ.companyGroup.usersIds = [];
    // } else {
    //   this.companyGroupServ.companyGroup.usersIds = { id: this.companyGroupServ.companyGroup.users.map(x => x.id) };
    // }

    if (this.companyGroup) {
      this.companyGroupServ.companyGroup.id = this.companyGroup.id;
      this.companyGroupServ
        .putCompanyGroup(this.companyGroupServ.companyGroup)
        .subscribe(
          () => { this.close() },
          () => {},
          () => { this.savedGroup() }
        );
    } else {

      this.companyGroupServ
        .postCompanyGroups(this.companyGroupServ.companyGroup)
        .subscribe(
          () => { this.close() },
          () => {},
          () => { this.savedGroup() }
        );
    }
  }

  close() {
    this.modalController.dismiss();
  }
  onInput() {
    this.growAuto = true;
  }

  async addUser() {
    this.addUserModalOpen = true;
    const modal = await this.modalCtrl.create({
      component: SelectModalUserComponent,
      componentProps: {
        label: "SELECT_USER",
        filtrIdCompany: this.companyId,
      },
      animated: true,
      cssClass: "add-edit-modal add-edit-modal--small",
    });

    modal.present();
    modal.onDidDismiss().then((data) => {
      this.addUserModalOpen = false;

      if (data.role !== "backdrop") {
        if (
          !this.companyGroupServ.companyGroup.users.some(
            (u) => u.id === data.data.id
          )
        ) {
          const newUser: UserBasic = this.parseToUserBasic(data.data)
          this.companyGroupServ.companyGroup.users.push(newUser);
          
        }
      }
    });
  }

  onRemoveUser(user) {
    this.companyGroupServ.companyGroup.users = this.companyGroupServ.companyGroup.users.filter(
      (el) => el.id !== user.id
    );
  }
    
  setHeader(): string {
    let header: string;
    if(this.groupType === CompanyGroupType.Department) {
      header = this.companyGroup === null ? 'DEPARTMENT.NEW_DEPARTMENT' : 'DEPARTMENT.EDIT_DEPARTMENT';
    } else {
      header = this.companyGroup == null ?  'COMPANY_GROUP.NEW_GROUP': 'COMPANY_GROUP.EDIT_GROUP';
    }
    return this.translate.instant(header);
  }

  parseToUserBasic(user: User): UserBasic {
    return {
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      mobilePhone: user.mobilePhone,
      telephone: user.telephone,
      idCompany: user.idCompany,
      carPlate: user.carPlate,
      company: user.company
    }
  }

  // function to prevent multiple click of save button
  private savedGroup() {
    setTimeout(() => {
      this.saving = false; 
    }, 500) 
  }
}
